import React, { useEffect } from "react";
import {
  Container,
  Grid,
  Box,
  Paper,
  Card,
  CardMedia,
  CardContent,
  Typography,
  Button,
} from "@mui/material";

import { useParams } from "react-router-dom";

import About from "./About";
import Home from "./Home";
import Skills from "./Skills";
import Projects from "./Projects";
import Contact from "./Contact";
import { useDispatch, useSelector } from "react-redux";
import { getDeveloper } from "../../features/Developers/developerSlice";
import Fotter from "../Home/Fotter";
// import Fotter from "../Home/Fotter";

const Dev = () => {
  const { developer, developers } = useSelector((state) => state.developers);

  const { dev } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDeveloper(dev));
  }, []);
  return (
    <>
      <Home developer={developer} />
      <About developer={developer} />
      <Skills developer={developer} />
      <Projects developer={developer} />
      <Contact developer={developer} />
      <Fotter />
    </>
  );
};

export default Dev;
